"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderFileLink = void 0;
var React = require("react");
var FileListLink_1 = require("components/FileListLink/FileListLink");
var RenderFileLink = function (_a) {
    var file = _a.file, baseUrl = _a.baseUrl, isMobile = _a.isMobile, token = _a.token, dataKey = _a.dataKey, index = _a.index, createLink = _a.createLink, getTarget = _a.getTarget, filename = _a.filename, section = _a.section;
    var link = createLink(file, baseUrl, isMobile, token, section);
    var target = getTarget(file, isMobile);
    return (React.createElement("div", { key: "".concat(index, "-name-meta"), "data-length": file.name.length, className: "row__column name ".concat(dataKey) },
        React.createElement(FileListLink_1.FileListLink, { file: file, link: link, isMobile: isMobile, target: target || '', filename: filename })));
};
exports.RenderFileLink = RenderFileLink;
